import React from 'react';

const HowToReach = () => {
  return (
    <>

      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/bg/breadcumb-bg.jpg')` }}      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">How to Reach Divyakshetra Hariharapura</h1>
          </div>
        </div>
      </div>
      <div className="travel-area space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div
                className="section-title text-center wow fadeInUp"
                data-wow-delay=".2s"
              >
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mt-4">
                <div className="row justify-content-center align-items-center gy-5">
                  <div className="col-lg-12">
                    <h4 className="title text-center">By Air</h4>
                  </div>
                  <div className="col-lg-7">
                    <ul>
                      <li>
                        <h6>Kempegowda International Airport, Bengaluru (BLR)</h6>
                        <p>
                          From Kempegowda International Airport, Bengaluru (BLR)
                          to Hariharapura (near Sringeri) is about 330 km
                          depending on the route.
                        </p>
                      </li>
                      <li>
                        <h6>Bajpe Airport, Mangalore (IXE)</h6>
                        <p>
                          The driving distance from Mangaluru International
                          Airport (in Mangalore) to Hariharapura is approximately
                          125 km.
                        </p>
                      </li>
                      <li>
                        <h6>Kuvempu Airport, Shivamogga (RQY)</h6>
                        <p>
                          The driving distance between Hariharapura and Shivamogga
                          (where the Shivamogga Airport is located) is
                          approximately 80 to 90 km.
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-5">
                    <img
                      style={{ width: '100%', borderRadius: '32px' }}
                      src="assets/img/how-to-reach/byair.jpg"
                      alt="plain"
                    />
                  </div>
                  <div className="col-lg-12">
                    <h4 className="title text-center">By Road</h4>
                  </div>
                  <div className="col-lg-5">
                    <img
                      style={{ width: '100%', borderRadius: '32px' }}
                      src="assets/img/how-to-reach/byroad.jpg"
                      alt="plain"
                    />
                  </div>
                  <div className="col-lg-7">
                    <ul>
                      <li>
                        <h6>From Bangalore</h6>
                        <p>
                          Direct KSRTC and private buses operate from Bangalore to
                          Hariharapura. Tickets can be conveniently booked online
                          through
                          <a
                            style={{ color: 'blue' }}
                            href="https://ksrtc.in/"
                            target="_blank"
                          >KSRTC</a
                          >.
                        </p>
                        <p>
                          You can also travel by <a
                            style={{ color: 'blue' }}
                            href="https://www.sugamatourists.com/"
                            target="_blank"
                          >Sugama Tourists</a
                          >,  or  <a
                            style={{ color: 'blue' }}
                            href="https://www.lvbusbooking.com/"
                            target="_blank"
                          >LV Tours & Travels </a
                          >. They offer
                          direct bus services from Bangalore to Hariharapura.


                        </p>
                      </li>

                      <li>
                        <h6>From Mangalore</h6>
                        <p>
                          Frequent KSRTC and private buses run from Mangalore to
                          Sringeri. From Sringeri, local buses and auto-rickshaws
                          are available to reach Hariharapura (approximately 20 km
                          away). Tickets can be booked online through
                          <a
                            style={{ color: 'blue' }}
                            href="https://ksrtc.in/"
                            target="_blank"
                          >KSRTC</a
                          >.
                        </p>
                      </li>

                      <li>
                        <h6>From Shivamogga</h6>
                        <p>
                          Direct KSRTC and private buses are available from
                          Shivamogga to Hariharapura, and also to nearby Sringeri.
                          Book your tickets easily through
                          <a
                            style={{ color: 'blue' }}
                            href="https://ksrtc.in/"
                            target="_blank"
                          >KSRTC</a
                          >.
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div className="col-lg-12">
                    <h4 className="title text-center">By Train</h4>
                  </div>
                  <div className="col-lg-7">
                    <ul>
                      <li>
                        <h6>From Bangalore</h6>
                        <p>
                          You can reach Shivamogga by train and then continue your
                          journey to Hariharapura by bus or taxi.
                        </p>
                      </li>
                      <li>
                        <h6>From Mangalore</h6>
                        <p>
                          You can reach Shivamogga or Udupi by train and then
                          continue your journey to Hariharapura by bus or taxi.
                        </p>
                      </li>
                      <li>
                        <h6>From Shivamogga or Udupi</h6>
                        <p>
                          From Shivamogga, you can take a bus going to Sringeri,
                          which passes near Hariharapura. The journey takes about
                          1.5 hours. <br />
                          From Udupi, you can take a bus going to Sringeri, which
                          passes near Hariharapura. The journey takes about 3.5 to
                          4 hours. <br />
                          Or, from both places, you can hire a taxi to reach
                          Hariharapura.
                        </p>
                      </li>
                      <li>
                        You can directly book your tickets on
                        <a
                          href="https://www.irctc.co.in/nget/train-search"
                          style={{ color: 'blue' }}
                          target="_blank"
                        >IRCTC</a
                        >.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-5">
                    <img
                      style={{ width: '100%', borderRadius: '32px' }}
                      src="assets/img/how-to-reach/bytrain.jpg"
                      alt="plain"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default HowToReach;
